import { useQuery } from '@tanstack/react-query';
import { ACCOUNT_ROLES } from '@elementary/common-ui/constants/queryKeys';
import * as rolesApi from '../../shared/rolesApi';

export const useRole = (roleId: string, enabled: boolean = true) => {
  const {
    data: role,
    isFetching: isLoading,
    error,
  } = useQuery({
    queryKey: [ACCOUNT_ROLES, roleId],
    queryFn: () => rolesApi.fetchRole(roleId),
    enabled: enabled && !!roleId,
  });

  const {
    data: users,
    isLoading: isLoadingUsers,
    error: usersError,
  } = useQuery({
    queryKey: [ACCOUNT_ROLES, roleId, 'users'],
    queryFn: () => rolesApi.fetchRoleUsers(roleId),
    enabled: enabled && !!roleId,
  });

  return {
    role,
    isLoading,
    error,
    users,
    isLoadingUsers,
    usersError,
  };
};
